import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ParticleSphereUIComponent } from '../../atoms/particle-sphere/particle-sphere.component';
import { IconUIComponent } from '../../atoms/icon/icon.component';
import { TranslatePipe } from '@ngx-translate/core';

// TODO: delete if not use
@Component({
  selector: 'fr8bot-ui-coming-soon',
  imports: [IconUIComponent, ParticleSphereUIComponent, TranslatePipe],
  templateUrl: './coming-soon.component.html',
  styleUrl: './coming-soon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComingSoonUIComponent {}
